import Chip, { type ChipProps } from '@mui/material/Chip';
import type { IdentityCardState } from '@/types';

const CARD_STATE: Record<IdentityCardState, { label: string; color: ChipProps['color'] }> = {
  unpublished: { label: 'Card not published', color: 'warning' },
  changes_pending: { label: 'Card: unpublished changes', color: 'info' },
  published: { label: 'Card published', color: 'success' },
  legacy: { label: 'Card live', color: 'success' },
};

export function IdentityCardStateChip({ state, sx }: { state?: IdentityCardState; sx?: ChipProps['sx'] }) {
  if (!state) return null;
  const cfg = CARD_STATE[state];
  return <Chip size="small" variant="outlined" label={cfg.label} color={cfg.color} sx={{ fontWeight: 600, ...sx }} />;
}
